/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type UpsertCommissionRateRequestBody = {
    shopId: string;
    feature: UpsertCommissionRateRequestBody.feature;
    rate: number;
};
export namespace UpsertCommissionRateRequestBody {
    export enum feature {
        CHECK_IMEI = 'CHECK_IMEI',
        CHECK_SLIP = 'CHECK_SLIP',
    }
}

